<template>
	<div class="work-home">
		<div class="work-home-s">
			<input type="text" v-model="address" id="address" class="work-home-input">
			<button type="button" @click="search" class="work-home-button">查询</button>
		</div>
		<div id="searchResultPanel" style="border:1px solid #C0C0C0;width:150px;height:150px; display:none;"></div>
		<div class="allmap" id="allmap"></div>
	</div>
</template>

<script>
	export default{
		name:'WorkHome',
		data(){
			return{
				address: '北京市',
				map: null
			}
		},
		methods:{
			// 根据id，获取dom对象
			getDId(id) {
				return document.getElementById(id);
			},
			
			// 普通搜索
			search(){
				let _this = this
				_this.map.clearOverlays()
				let local = new BMap.LocalSearch(_this.map,{
					renderOptions: { 
						map: _this.map
					}
				})
				local.search(this.address)
				_this.map.centerAndZoom(_this.address,13)
			},
			
			// 智能搜索
			autoSearch(){
				let _this = this
				_this.map.clearOverlays()    //清除地图上所有覆盖物
				let local = new BMap.LocalSearch(this.map, {
					//智能搜索
					onSearchComplete: function(){
						let pp = local.getResults().getPoi(0).point;    //获取第一个智能搜索的结果
						_this.map.centerAndZoom(pp, 13);
						_this.map.addOverlay(new BMap.Marker(pp));    //添加标注
					}
				})
				local.search(_this.address)
			},
			
			// 添加输入提示
			inputTips(){
				let _this = this
				//建立一个自动完成的对象
				let ac = new BMap.Autocomplete({
					"input" : "address",
					"location" : _this.map
				})
				
				//鼠标放在下拉列表上的事件
				ac.addEventListener("onhighlight", function(e) {
					let str = ""
					let value = ""
					let _value = e.fromitem.value
					if (e.fromitem.index > -1) {
						value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business
					}    
					str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;

					value = ""
					if (e.toitem.index > -1) {
						_value = e.toitem.value
						value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business
					}    
					str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value
					_this.getDId("searchResultPanel").innerHTML = str
				})
			
				//鼠标点击下拉列表后的事件
				ac.addEventListener("onconfirm", function(e) {
					let _value = e.item.value
					_this.address = _value.province +  _value.city +  _value.district +  _value.street +  _value.business
					_this.getDId("searchResultPanel").innerHTML ="onconfirm<br />index = " + e.item.index + "<br />myValue = " + _this.address
					_this.autoSearch()
				})
			}
		},
		mounted() {
			let _this = this
			// 百度地图API功能
				_this.map = new BMap.Map("allmap");    // 创建Map实例
				_this.map.centerAndZoom(new BMap.Point(116.404, 39.915), 11);  // 初始化地图,设置中心点坐标和地图级别
				//添加地图类型控件
				_this.map.addControl(new BMap.MapTypeControl({
					mapTypes:[
			            BMAP_NORMAL_MAP,
			            BMAP_HYBRID_MAP
			        ]}));	  
				_this.map.setCurrentCity(_this.address);          // 设置地图显示的城市 此项是必须设置的
				_this.map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
				_this.map.addEventListener('click', function (e) {
					console.log(e)
				    // alert('点击位置经纬度：' + e.latlng.lng + ',' + e.latlng.lat);
				});
				_this.inputTips()
		}
	}
</script>

<style>
	.work-home{
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}
	.allmap{
		width: 100%;
		height: 100%;
	}
	.work-home-s{
		padding: 10px 2px;
	}
	.work-home-input{
		height: 30px;
		line-height: 30px;
		padding: 0 5px;
		border: 1px solid #CCCCCC;
		margin-right: 5px;
		border-radius: 4px;
		width: 260px;
	}
	.work-home-button{
		background-color: #009688;
		color: #FFFFFF;
		height: 30px;
		width: 50px;
		border-radius: 4px;
		cursor: pointer;
	}
</style>
